<script setup lang="ts">
import {
  RampInstantSDK,
  RampInstantEventTypes,
} from "@ramp-network/ramp-instant-sdk";

const router = useRouter();
const emit = defineEmits(["close"]);
const { refreshUserFinancials } = useBalanceRefresh();
const { rampKey, rampUrl, clientUrl, serverUrl } = useRuntimeConfig().public;
const { trackEvent } = useGAnalytics();
const userStore = useUserStore();
const { $serverApi } = useNuxtApp();

let ramp: RampInstantSDK | null = null;

const rampStuff = {
  hostAppName: "GFAL",
  hostLogoUrl: `${clientUrl}/img/GFAL_logo_name.png`,
  hostApiKey: rampKey,
  swapAsset: "BSC_GFAL",
  fiatCurrency: "EUR",
  fiatValue: "20",
  userAddress: userStore.accountAddress ?? "",
  userEmailAddress: userStore.email,
  webhookStatusUrl: `${serverUrl}/api/transactions/onramp`,
};

const getRampUrl = async () => {
  try {
    const params = new URLSearchParams(rampStuff as any).toString();
    const response = await $serverApi(`/api/ramp?${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${useUserStore().authToken}`,
      },
    });
    if (response && response.statusCode === 200 && response.payload) {
      return response.payload.url;
    }
  } catch (error) {
    console.error("Error fetching Ramp signed URL:", error);
  }
  return rampUrl;
};

onMounted(async () => {
  const signedUrl = await getRampUrl();

  ramp = new RampInstantSDK({
    url: signedUrl,
  });
  ramp
    .on(RampInstantEventTypes.WIDGET_CLOSE, (event): void => {
      trackEvent("onRamp_close");
      refreshUserFinancials();
      emit("close", event);
    })
    .on(RampInstantEventTypes.PURCHASE_CREATED, (event): void => {
      trackEvent("onRamp_purchase_created", event);
    })
    .show();
});

onUnmounted(() => {
  if (ramp) {
    ramp.close();
  }
  router.replace({ query: {} });
});
</script>

<template>
  <div id="ramp-container" />
</template>
